<template>
  <div>
    <div v-if="env === 'development'">
    <func-default-dev></func-default-dev>
    </div>
    <div v-if="env !== 'development'">
      <func-default-prod></func-default-prod>
    </div>
  </div>
</template>
<script>
import FuncDefaultDev from '@/views/FuncDefault/FuncDefaultDev'
import FuncDefaultProd from '@/views/FuncDefault/FuncDefaultProd'
export default {
  components: {
    FuncDefaultDev,
    FuncDefaultProd
  },
  data () {
    return {
      env: process.env.NODE_ENV
    }
  }
}
</script>
